import { render, staticRenderFns } from "./BatteryHealthHelpContent.vue?vue&type=template&id=fa67b398"
import script from "./BatteryHealthHelpContent.vue?vue&type=script&lang=ts"
export * from "./BatteryHealthHelpContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports